module.exports = __webpack_public_path__ + "static/media/Livechat.aa4b37c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Livechat.svg
// module id = 298
// module chunks = 25